<h2 class="alert alert-danger" *ngIf="error">
  {{ error }} Kayıt ve internet durumunuzu kontrol ediniz.
</h2>
<h1>{{ record }}</h1>
<br />
<br />
<button (click)="toggle()">
  {{ !newJob ? "Yeni İş Kaydı Oluştur" : "Kayıtlı İşler" }}
</button>

<div *ngIf="newJob">
  <h1>
    {{ !viewUpdateJob ? "Yeni İş Kayıdı Oluştur" : "İş Kaydını Güncelle" }}
  </h1>
  <p></p>
  <table style="border: 1px solid black; width: 100%">
    <tr>
      <td style="width: 20%">
        <strong>Konu Başlığı</strong>
      </td>
      <td>
        <input type="text" [(ngModel)]="recordTitle" style="width: 95%"
        (ngModelChange)="recordTitle = $event.toLowerCase()"/>
      </td>
    </tr>
    <tr>
      <td style="width: 20%">
        <strong>İşin Türü</strong><em>(Ön Araştırma, TBD,FTO...)</em>
      </td>
      <td>
        <input type="text" [(ngModel)]="recordType" style="width: 95%"
        (ngModelChange)="recordType= $event.toLowerCase()"/>
      </td>
    </tr>
    <tr>
      <td style="width: 20%">
        <strong>İşin Detaylı Açıklaması</strong>
      </td>
      <td>
        <textarea
          type="text"
          [(ngModel)]="recordDetail"
          (ngModelChange)="recordDetail = $event.toLowerCase()"
          style="width: 95%"
          rows="5"
          cols="42"
        >
        </textarea>
      </td>
    </tr>

    <tr>
      <td style="width: 20%">
        <strong>İlgili Vekil</strong>
      </td>
      <td>
        <input type="text" [(ngModel)]="recordAttorney" style="width: 95%"
        (ngModelChange)="recordAttorney= $event.toLowerCase()"/>
      </td>
    </tr>
    <tr>
      <td style="width: 20%">
        <strong>Termin Tarihi</strong>
      </td>
      <td>
        <input
          type="date"
          [(ngModel)]="recordTermination"
          style="width: 95%"
          rows="5"
          cols="42"
        />
      </td>
    </tr>
  </table>
  <br />
  <button
    *ngIf="!viewUpdateJob"
    style="margin-right: 5%"
    (click)="onSubmit()"
    class="btn"
  >
    İşi Kaydet
  </button>
  <button
    *ngIf="viewUpdateJob"
    style="margin-right: 5%"
    (click)="onUpdate()"
    class="btn"
  >
    İş Kaydını Güncelle
  </button>
</div>
<div *ngIf="!newJob">
  <input
    class="form-control"
    class="icon"
    type="text"
    name="search"
    [(ngModel)]="searchText"
    (ngModelChange)="searchText= $event.toLowerCase()"
    autocomplete="off"
    placeholder="Kayıtlar Üzerinden Ara"
    id="input1"
  />
  <p></p>
  <table>
    <thead>
      <th>No.</th>
      <th>Konu Başlığı</th>
      <th>İş Türü</th>
      <th>İşin Detayı</th>

      <th>Patent Vekili</th>
      <th>Son Tarih</th>
      <th>Kaydı Yapan</th>
      <th>Son Durum</th>
      <th>Durumu Güncelle</th>
    </thead>
    <tbody>
      <tr
        [style.background-color]="
          item.status[0].includes('tamamlandı') ? 'green' : 'red'
        "
        *ngFor="let item of docLink | filter: searchText; let i = index"
      >
        <td>{{ i + 1 }}</td>
        <td>{{ item.recordTitle | json }}</td>
        <td>{{ item.recordType | json }}</td>
        <td>{{ item.detail | json }}</td>
        <td>{{ item.attorneyName | json }}</td>
        <td>{{ item.terminationDate | date: "dd/MM/yyyy" }}</td>
        <td>
          e-posta: {{ item.LoggedUser[0].recordingUser }} / Tarih:{{
            item.LoggedUser[0].date | date: "dd/MM/yyyy"
          }}
        </td>
        <td>
          {{ item.status[0] ? item.status[0] : "devam ediyor" }}
        </td>
        <td>
          <button *ngIf="item.status" (click)="jobDone(i)">
            {{
              item.status[0].includes("tamamlandı")
                ? "devam ediyor"
                : "tamamlandı"
            }}
          </button>
        </td>
        <td style="background-color: #f8f9fb">
          <button (click)="updateJob(i)">Buluş Bilgilerini Güncelle</button>
        </td>
      </tr>
    </tbody>
  </table>
</div>
